import React from 'react';
import { Parallax } from 'react-parallax';

const ImageBox = () => {
    return (
        <section className="image-box">
            <Parallax
                bgImage={require('../../../assets/office.jpg')}
                bgImageAlt="Zdjęcie gabinetu"
                strength={300}
                bgClassName="image-box__image"
                className="image-box__parallax-container"
            >
                <div className="container image-box__parallax-title">
                    <div className="image-box__title-box">
                        <h1 className="image-box__title">Usługi</h1>
                        <div className="image-box__title-hr"></div>
                    </div>
                </div>
            </Parallax>
        </section>
    );
}

export default ImageBox;